var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-up',{attrs:{"team-id":_vm.teamId,"actions":_vm.actions,"data":_vm.data}})}
var staticRenderFns = []
export { render, staticRenderFns }